<template>
  <div class="flex flex-col gap-2 px-4 border-t">
    <div class="font-bold mt-2">{{ $t("painting.proportion") }}</div>

    <div class="flex px-6 my-4 gap-6">
      <div
        v-for="item in ['3:4', '16:9']"
        :key="item"
        :class="[
          'flex flex-col items-center border relative',
          reqData.ratio === item
            ? 'border-primary'
            : 'border-transparent opacity-50',
        ]"
        @click="reqData.ratio = item"
      >
        <VanImage
          :src="
            item === '3:4'
              ? `/img/mate-wish/3-4.png`
              : `/img/mate-wish/16-9.png`
          "
          :class="[
            ' h-full min-h-[105px]',
            `aspect-[${item === '3:4' ? '3/4' : '16/9'}]`,
          ]"
          crossorigin="anonymous"
          alt=""
        />

        <span
          class="font-bold my-2 absolute -bottom-8 left-[50%] translate-x-[-50%]"
        >
          {{ item }}
        </span>

        <CheckCircleFillIcon
          :class="[
            'iconfont icon-check-circle-fill icon-xl absolute top-1 left-1',
            reqData.ratio === item ? 'text-primary' : 'opacity-0',
          ]"
        />
      </div>
    </div>

    <div class="font-bold mt-4">
      {{ $t("painting.numberGeneratedImages") }}
    </div>
    <div class="flex justify-between items-center gap-4 mt-2">
      <div>1</div>
      <VanSlider v-model="reqData.amount" :min="1" :max="12" size="sm">
        <template #button>
          <button class="btn btn-circle btn-xs">
            {{ reqData.amount }}
          </button>
        </template>
      </VanSlider>
      <div>12</div>
    </div>
    <VanCell
      center
      :title="$t(`collection.isPublic`)"
      class="p-0 mt-4 bg-transparent"
    >
      <template #right-icon>
        <VanSwitch
          v-model="reqData.isNotShown"
          size="20"
          :active-value="false"
          :inactive-value="true"
        />
      </template>
    </VanCell>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from "vue";

defineProps({
  reqData: {
    type: Object as PropType<PromptJson>,
    required: true,
  },
});

const emit = defineEmits(["update:ratio", "update:genCount"]);
</script>
